import truncateStringFilter from 'filters/truncateStringFilter';
import localizeFilter from 'filters/localizeFilter';
import decimalFilter from 'filters/decimalFilter';
import phoneNumberFilter from 'filters/phoneNumberFilter';
import utcFilter from 'filters/utcFilter';
import momentFilter from 'filters/momentFilter';
import venueCurrencyFilter from 'filters/venueCurrencyFilter';
import limitFilter from 'filters/limitFilter';
import percentageFilter from 'filters/percentageFilter';
import tlCurrencyFilter from 'filters/tlCurrencyFilter';

function init(app) {
  if (!app) throw new Error('app is required');

  app.filter('truncateString', truncateStringFilter);
  app.filter('localize', localizeFilter);
  app.filter('decimal', decimalFilter);
  app.filter('phoneNumber', phoneNumberFilter);
  app.filter('utc', utcFilter);
  app.filter('moment', momentFilter);
  app.filter('venueCurrency', venueCurrencyFilter);
  app.filter('limit', limitFilter);
  app.filter('percentage', percentageFilter);
  app.filter('tlCurrency', tlCurrencyFilter);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/filters/index.js